<template>
  <div>
    <div class="mb-2">
      <label>Тема письма</label>
      <input type="text" disabled class="form-control" name="subject"
             v-validate="'required|min:10|max:1000'"
             data-vv-as="Тема письма"
             placeholder="Ваш заказ..."
             v-model="localLetter.subject">
      <small class="form-text text-danger" v-if="errors.has('subject')">
        {{ errors.first('subject') }}
      </small>
    </div>
    <div v-if="letter.type === 6 && !order.extra_options.post_track" class="alert alert-danger">
      <p>отсутствует номер посылки для отслеживания</p>
    </div>
    <template v-if="bodyBlocks[0]">
      <ckeditor :editor="editor" v-model="bodyBlocks[0]" :config="editorConfig"></ckeditor>
    </template>
    <div v-if="fixedBlock" class="alert alert-dark mb-0" v-html="fixedBlock"/>
    <template v-if="bodyBlocks[1]">
      <ckeditor :editor="editor" v-model="bodyBlocks[1]" :config="editorConfig"></ckeditor>
    </template>
  </div>
</template>

<script>

import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  props: ['letter', 'card', 'cards', 'order'],
  components: {
    ckeditor: CKEditor.component,
  },
  watch: {
    card() {
      this.parseLetter();
    },
    letter() {
      this.parseLetter();
    }
  },
  created() {
    this.parseLetter();
  },
  computed: {
    $AllProjects() {
      return this.$store.getters['platform/projects'].reduce((acc, p) => {
        acc[p.id] = p;
        return acc;
      }, {})
    },
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
      localLetter: {},
      fixedBlock: false,
      bodyBlocks: [],
    }
  },
  methods: {
    parseLetter() {
      this.localLetter = {...this.letter}
      if (!this.localLetter.id) return;
      this.localLetter.subject = this.localLetter.subject.replaceAll('${site_source}', this.$AllProjects[this.order.site_id].name);
      this.localLetter.subject = this.localLetter.subject.replaceAll('${orderNo}', (this.order.id + '').substring((this.order.id + '').length - 4));
      let textArray = this.letter.body.split('${fixedBlock}');
      let fixedBlock = null;
      if (this.letter.fixed_block) {
        fixedBlock = this.parseBlock(this.letter.fixed_block);
        fixedBlock += '<p>Вам необходимо внести оплату <strong>${total_price}</strong> рублей</p>';
        fixedBlock += '<p>(<strong>${preps_price}</strong> стоимость препарата(ов) и <strong>${delivery_price}</strong> стоимость упаковки и услуг почты России)</p>';
        if (this.cards.length > 1) {
          fixedBlock += '<p>Оплата частями</p>'
          this.cards.forEach((c) => {
            if (c.card_id) {
              fixedBlock += `<p>на QiWi кошелек <strong>${c.card.number}</strong> cумма <strong>${c.sum}</strong></p>`
            }
          })
        } else if (this.cards[0].card_id) {
          fixedBlock += `<p>на QiWi кошелек <strong>${this.cards[0].card.number}</strong></p>`
        }
        fixedBlock = this.parseBlock(fixedBlock);
      }
      textArray.forEach((t, i) => {
        textArray[i] = this.parseBlock(t);
      })
      this.bodyBlocks = textArray;
      this.fixedBlock = fixedBlock;
    },
    parseBlock(text) {
      let drugs = '';
      this.order.details.forEach((d) => {
        drugs += `<p>${d.new_drug.title} * ${d.qty}шт.</p>`;
      })
      text = text.replaceAll('${preps}', drugs);
      text = text.replaceAll('${preps_qnty_prices}', drugs);
      text = text.replaceAll('${preps_price}', this.order.details.reduce((acc, d) => acc + (d.qty * d.price), 0));
      text = text.replaceAll('${delivery_price}', (this.order.delivery_price || 0));
      text = text.replaceAll('${name}', this.order.client_name);
      text = text.replaceAll('${total_price}', this.order.price);
      text = text.replaceAll('${orderNo}', (this.order.id + '').substring(-4));
      text = text.replaceAll('${site_source}', this.$AllProjects[this.order.site_id].name);
      text = text.replaceAll('${postTrackNum}', this.order.extra_options.post_track);
      if (this.order.paymentLink) {
        let l = `<a href="${this.order.paymentLink}">тут</a>`;
        text = text.replaceAll('${payLink}', l);
      }


      if (this.card) {
        text = text.replaceAll('${bankAcc}', this.card.number);
        text = text.replaceAll('${cardHolder}', this.card.owner.short_name);
        const cardNumber = this.card.number;
        text = text.replaceAll('${card}', `${cardNumber.substring(0, 4)}-${cardNumber.substring(4, 8)}-${cardNumber.substring(8, 12)}-${cardNumber.substring(12, 16)}`);
      }
      return text;
    },
    getLetterText() {
      let text = this.bodyBlocks[0];
      if (this.fixedBlock) text += this.fixedBlock;
      if (this.bodyBlocks[1]) text += this.bodyBlocks[1];
      return {
        subject: this.localLetter.subject,
        body: text
      }
    }
  }
}

</script>
